export default __webpack_public_path__ + "static/media/mailchimp_small.f6ea8ec5.svg";